import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { SetNewPasswordResponse } from '../../../api/hub-responses/set-new-password-response';
import { container } from '../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../utils/container/service-ids';
import { FlagNames } from '../../../utils/feature-flags/flag-names';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type SetNewEmailPasswordRequest = {
    expires: number,
    email: string,
    token: string,
    password: string,
    locale: string
}

export function setNewEmailPassword(data: SetNewEmailPasswordRequest): Promise<SetNewPasswordResponse> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

    if (!isHubApiEnabled) {
        return HubJsonRpcRequest.makeRequest<SetNewPasswordResponse, SetNewEmailPasswordRequest>(
            HubApiMethods.SET_NEW_PASSWORD,
            data,
            window.app.deviceIdentifier
        );
    } else {
        const hubApi = getHubApi();
        return hubApi.setNewPassword(window.app.deviceIdentifier, data) as Promise<SetNewPasswordResponse>;
    }
}
